import React, { useState } from 'react';
import { Card, Row, Col, Container, Pagination } from 'react-bootstrap';
import '../styles/FeaturedLeases.css'

const FeaturedLeases = () => {
    const backgroundImage='/assets/images/FeaturedList.jpg'

    const listings = [
        {
          id: 1,
          status: "For Sale",
          image: "/assets/images/house1.avif",
          address: "1234 Elm St, Springfield, IL 62701",
          price: "$1,200,000",
          features: ["4 Bedrooms", "3 Bathrooms", "2,500 Sq.Ft."]
        },
        {
          id: 2,
          status: "Coming Soon",
          image: "/assets/images/house2.avif",
          address: "5678 Oak Dr, Chicago, IL 60601",
          price: "$3,500,000",
          features: ["6 Bedrooms", "5 Bathrooms", "4,000 Sq.Ft."]
        },
        {
          id: 3,
          status: "For Sale",
          image: "/assets/images/house3.avif",
          address: "7890 Pine Ave, Peoria, IL 61602",
          price: "$750,000",
          features: ["3 Bedrooms", "2 Bathrooms", "1,800 Sq.Ft."],
          openHouse: "Open House: 12/20/2024, 2:00 PM - 5:00 PM"
        },
        {
          id: 4,
          status: "Sold",
          image: "/assets/images/house4.avif",
          address: "2345 Maple Dr, Bloomington, IL 61701",
          price: "$950,000",
          features: ["4 Bedrooms", "3 Bathrooms", "2,200 Sq.Ft."]
        },
        {
          id: 5,
          status: "For Sale",
          image: "/assets/images/house3.avif",
          address: "3456 Cedar Ln, Springfield, IL 62702",
          price: "$1,500,000",
          features: ["5 Bedrooms", "4 Bathrooms", "3,000 Sq.Ft."]
        },
        {
          id: 6,
          status: "Coming Soon",
          image: "/assets/images/house2.avif",
          address: "4567 Birch Blvd, Decatur, IL 62521",
          price: "$2,200,000",
          features: ["6 Bedrooms", "5 Bathrooms", "3,800 Sq.Ft."]
        },
        {
            id: 7,
            status: "For Sale",
            image: "/assets/images/house4.avif",
            address: "9812 Magnolia St, Aurora, IL 60504",
            price: "$1,250,000",
            features: ["5 Bedrooms", "4 Bathrooms", "2,600 Sq.Ft."]
          },
          {
            id: 8,
            status: "Coming Soon",
            image: "/assets/images/house3.avif",
            address: "4521 Lakeview Rd, Naperville, IL 60563",
            price: "$3,400,000",
            features: ["6 Bedrooms", "5 Bathrooms", "4,200 Sq.Ft."]
          },
          {
            id: 9,
            status: "For Sale",
            image: "/assets/images/house2.avif",
            address: "3019 Willow Lane, Champaign, IL 61821",
            price: "$720,000",
            features: ["3 Bedrooms", "2 Bathrooms", "1,750 Sq.Ft."],
            openHouse: "Open House: 01/15/2025, 1:00 PM - 4:00 PM"
          },
          {
            id: 10,
            status: "Sold",
            image: "/assets/images/house1.avif",
            address: "1284 Maplewood Dr, Joliet, IL 60431",
            price: "$980,000",
            features: ["4 Bedrooms", "3 Bathrooms", "2,300 Sq.Ft."]
          },
          {
            id: 11,
            status: "For Sale",
            image: "/assets/images/house4.avif",
            address: "6523 Forest Ln, Rockford, IL 61109",
            price: "$1,450,000",
            features: ["5 Bedrooms", "4 Bathrooms", "3,100 Sq.Ft."]
          },
          {
            id: 12,
            status: "Coming Soon",
            image: "/assets/images/house3.avif",
            address: "7592 Sunset Blvd, Evanston, IL 60201",
            price: "$2,150,000",
            features: ["6 Bedrooms", "5 Bathrooms", "3,750 Sq.Ft."]
          }
      ];

        const itemsPerPage = 6;
        const [currentPage, setCurrentPage] = useState(1);

        // Calculate pagination
        const totalPages = Math.ceil(listings.length / itemsPerPage);
        const startIdx = (currentPage - 1) * itemsPerPage;
        const currentListings = listings.slice(startIdx, startIdx + itemsPerPage);

        // Change Page
        const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
        const handleNext = () => {
          if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
          }
        };
      
        const handlePrevious = () => {
          if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
          }
        };

  return (
    <div>
        <div className="video-container" style={{ marginTop: "0", padding: "100px 20px" }}>
        {/* Background Image */}
        <img className='video-background' src={backgroundImage} alt='background-image'/>

        {/* Content Overlay */}
        <div className="content">
            <h1>Our Featured Leases</h1>
            <strong>Alex Turner leases real estate in Beverly Hills & beyond. Contact Alex to rent property in Bel Air, Malibu & more.</strong>
        </div>
        </div>

        <div style={{color: "#ffffff", minHeight: "100vh", padding: "20px 0" }} className='bg-dark'>
      <Container className="mt-4">
        <Row className="justify-content-center">
          {currentListings.map((listing) => (
            <Col key={listing.id} md={6} className="mb-4 d-flex justify-content-center">
              <Card style={{ width: "100%", maxWidth: "500px", color: "#ffffff" }} className='bg-dark image-container'>
                <Card.Img
                  variant="top"
                  src={listing.image}
                  alt="House Image"
                   className="property-image"
                  style={{ width: "100%", height: "auto", objectFit: "cover" }}
                />
                 {listing.openHouse && (
                    <div className="open-house-label">
                    {listing.openHouse}
                    </div>
                )}
                <Card.Body style={{ width: "100%", height: "auto"}} className='bg-dark'>
                  <Card.Title>{listing.address}</Card.Title>
                  <Card.Text>
                     {listing.status}
                    <br />
                     {listing.price}
                    <br />
                    {listing.features.join(" | ")}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Pagination */}
        <Row className='mt-5'>
          <Col className="d-flex justify-content-center">
            <Pagination>
              <Pagination.Prev onClick={handlePrevious} disabled={currentPage === 1} >
                &lt;
              </Pagination.Prev>
              {[...Array(totalPages).keys()].map((page) => (
              <Pagination.Item
                key={page + 1}
                active={currentPage === page + 1}
                onClick={() => handlePageChange(page + 1)}
                className='mx-2'
                style={{
                    background: currentPage === page + 1 ? "white" : "transparent",
                    color: currentPage === page + 1 ? "black" : "white",
                    border: "none",
                  }}
              >
                {page + 1}
              </Pagination.Item>
            ))}
              <Pagination.Next onClick={handleNext} disabled={currentPage === totalPages}>
                &gt;
              </Pagination.Next>
            </Pagination>
          </Col>
        </Row>
      </Container>
    </div>
    </div>
  )
}

export default FeaturedLeases